var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-title-section",class:{ dark: _vm.dark }},[_c('div',{staticClass:"title"},[_vm._t("default")],2),(_vm.$slots.subtitle)?_c('div',{staticClass:"subtitle"},[_vm._t("subtitle")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }